import { useCallback } from 'react';
import ComplementDB from '../../../../../database/wrappers/complement';
import useBasePriceImport from '../../product/hooks/useBasePriceImport';

const chunkArray = (list, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < list.length; i += chunkSize) {
    chunks.push(list.slice(i, i + chunkSize));
  }
  return chunks;
};

const useComplementPriceImport = ({ establishmentId, complements, onShowAlert }) => {
  const handleSaveRows = useCallback(async (rowsToUpdate) => {
    const complementDB = new ComplementDB(establishmentId);
    const chunks = chunkArray(rowsToUpdate, 200);

    for (const chunk of chunks) {
      await Promise.all(chunk.map((item) => complementDB.update(item.id, { price: item.newPrice })));
    }
  }, [establishmentId]);

  return useBasePriceImport({
    canImport: !!establishmentId,
    products: complements,
    onShowAlert,
    onSaveRows: handleSaveRows,
    messages: {
      saveError: 'Falha ao atualizar preços dos complementos.',
    },
  });
};

export default useComplementPriceImport;
